import { render, staticRenderFns } from "./desktop-footer.vue?vue&type=template&id=52da6e5d&scoped=true&"
var script = {}
import style0 from "./desktop-footer.vue?vue&type=style&index=0&id=52da6e5d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52da6e5d",
  null
  
)

component.options.__file = "desktop-footer.vue"
export default component.exports